import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import dayjs from 'dayjs';
import { RootState } from '~/store/config';
import * as actionTypes from './actionTypes';

export const resetHistoryFilterOptions = () => async (
  dispatch: Dispatch<AnyAction>,
  getState: () => RootState
) => {
  const { userTimeZone } = getState().auth;

  const dateRange = {
    start: dayjs()
      .tz(userTimeZone)
      .subtract(1, 'day')
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ss'),
    end: dayjs()
      .tz(userTimeZone)
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss'),
  };

  dispatch({
    type: actionTypes.RESET_HISTORY_FILTER_OPTIONS,
    payload: dateRange,
  });
};
